import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  IPlatformToolComponent,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';
import { MagicLinkModel, TabModel, ToolItem } from '@shared/models/platform-tool-models';
import { PlatformDialogHelper } from '@shared/components/platform-tool/platform-tool-dialog-definition/models/platform-dialog-helper';
import { PlatformCommand, PlatformCommandResponse } from '@shared/commands/command-base';
import { PlatformDialogService } from '@shared/components/platform-tool/platform-tool-dialog-definition/services/platform-dialog.service';

@Component({
  selector: 'app-orbitax-connect-dialog-definition-form-view-component',
  standalone: false,
  templateUrl: './orbitax-connect-dialog-definition-form-view-component.component.html',
  styleUrl: './orbitax-connect-dialog-definition-form-view-component.component.scss'
})
export class OrbitaxConnectDialogDefinitionFormViewComponentComponent implements OnInit, IPlatformToolComponent, OnDestroy {
  handler: IPlatformToolHandler;
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  selectedTab: TabModel;
  api: string;
  platformDialogId: string;
  isCustomConnection: boolean;
  private submitCommand: PlatformCommand;
  public refreshCommand: PlatformCommand;
  private autoSaveCommand: PlatformCommand;
  private dialogDefinitionListenerCommands: PlatformCommand[] = [];
  private commandsToDisableOnInvalidPlatformDialog: PlatformCommand[] = [];
  constructor(private platformDialogService: PlatformDialogService) { }

  ngOnInit(): void {
    this.api = this.selectedTab.tabData['Api'];
    this.platformDialogId = this.selectedTab.tabData['PlatformDialogId'];
    this.refreshCommand = this.selectedTab.tabData['RefreshCommand'];
    this.autoSaveCommand = this.magicLinkModel.additionalCommands['AutoSaveCommand'];
    this.isCustomConnection = this.selectedTab.tabData['IsCustomConnection'];
  }

  onFormValueChanged($event: any) {
    this.populateNextButtonFieldValues($event);
    if(this.validateMandatoryFields($event))
    {
      this.magicLinkModel.tabBar.nextButtonCommand.isDisabled = false;
    }
    else 
    {
      this.magicLinkModel.tabBar.nextButtonCommand.isDisabled = true;
    }
  }

  onDialogInit($event: any) {
    this.dialogDefinitionListenerCommands.forEach(command => {
      PlatformDialogHelper.setDialogDefinitionValues(command, $event);
    });
  }

  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
  }

  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
  }

  onBeforeExecuteNextCommand(): boolean {
    return true;
  }

  onBeforeExecutePreviousCommand(): boolean {
    return true;
  }

  onLoad() {
  }

  ngOnDestroy(): void {

  }

  private populateNextButtonFieldValues(event: any): void {
    if (!event?.dialogDefinitions?.length) return;

    for (const dialogDefinition of event.dialogDefinitions) {
      for (const field of dialogDefinition.fields ?? []) {
        if (field?.key != null) {
          this.magicLinkModel.tabBar.nextButtonCommand.fieldValues[field.key] = field.value;
        }
      }
    }
  }

  private validateMandatoryFields(event: any): boolean {
    if (!event?.dialogDefinitions?.length) return false;

    for (const dialogDefinition of event.dialogDefinitions) {
      for (const field of dialogDefinition.fields ?? []) {
        if (field?.isMandatory) {

        const value = (field.value ?? '').toString().trim();
        if (value.length === 0) {
          return false; // Mandatory field is empty or only whitespace
        }

        }
      }
    }

    return true; // All mandatory fields have a value
  }


}
